import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function BasicSelect(props) {
    const [option, setOption] = React.useState(props.label);
    const handleChange = (event) => {
        setOption(event.target.value);
    };
    console.log("labvel0", props.label)
    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
                <InputLabel sx={{ color: "grey !important", fontSize: 18, '&.MuiInputLabel-root.Mui-focused': { color: "#FF4D30 !important" } }} shrink={true}>{props.label + "*"}</InputLabel>
                <Select
                    id={props.label}
                    value={option}
                    label={props.label + "12"}
                    onChange={handleChange}
                    sx={{
                        color: "grey", borderColor: 'grey', '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'grey !important',
                            '& .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-shrink.MuiInputLabel-standard.MuiFormLabel-colorPrimary.MuiFormLabel-filled.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-shrink.MuiInputLabel-standard': {
                                color: '#2E98EF'
                            }
                        }
                    }}
                >
                    <MenuItem value={props.label} disabled>{props.label}</MenuItem>
                    {props.options.map((option) =>
                        <MenuItem value={option.name}>{option.name}</MenuItem>
                    )}
                </Select>
            </FormControl>
        </Box >
    );
}